import application from 'application/application';

import template from './keywords-details.template.html';

import controller from './keywords-details.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.publications.keywords.keywordsDetails', {
				url: '/:keywordsIDs',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				}
			});

	}]);
